import React from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    BlueTint 
} from '../../Styles/BaseStyles'

import { 
    ACDDiv,
    ACDComponentsDiv,
    QuickFillerButtonDiv,
    ACDTextDiv,
    ACDTitle,
    ACDPhraseDiv,
    ACDExitPhraseDiv,
    QuickFillerButton,
    ACDExitPhrase,
    HereLink
} from '../../Styles/Components/AccountConfirmDispStyles'

import { useSelector, useDispatch } from 'react-redux'
import { reset } from '../../Redux/Slices/AccountConfirmSlice'

function AccountConfirmDisp(props){
    var history = useHistory()

    const dispatch = useDispatch()

    const accountConfirmed = useSelector(state => state.accountConfirm.accountConfirmed)
    const error = useSelector(state => state.accountConfirm.error)
    const email = useSelector(state => state.accountConfirm.email)
    const errorPhrase = useSelector(state => state.accountConfirm.errorPhrase)

    var viewer

    function mainPage(e){
        history.push('/')
    }

    if(accountConfirmed && !error){
        viewer = (
            <ACDDiv id="account-confirm-section">
                <ACDComponentsDiv>
                    <ACDTextDiv>
                        <QuickFillerButtonDiv>
                            <QuickFillerButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                        </QuickFillerButtonDiv>
                        <ACDTitle>Account Verification Successful!</ACDTitle>
                        <ACDPhraseDiv>Successfully verified QuickFiller account {email}.</ACDPhraseDiv>
                        <ACDExitPhraseDiv>
                            <ACDExitPhrase>Click <HereLink href='' onClick={loginPageTransition}>here</HereLink> to go back to the Log In page.</ACDExitPhrase>
                        </ACDExitPhraseDiv>
                    </ACDTextDiv>
                </ACDComponentsDiv>
            </ACDDiv>
        )
    }
    else if(!accountConfirmed && error){
        viewer = (
            <ACDDiv id="account-confirm-section">
                <ACDComponentsDiv>
                    <ACDTextDiv>
                        <QuickFillerButtonDiv>
                            <QuickFillerButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                        </QuickFillerButtonDiv>
                        <ACDTitle>Account Verification Failed!</ACDTitle>
                        <ACDPhraseDiv>{errorPhrase}</ACDPhraseDiv>
                        <ACDExitPhraseDiv>
                            <ACDExitPhrase>Click <HereLink href='' onClick={mainPageTransition}>here</HereLink> to go back to the Main page.</ACDExitPhrase>
                        </ACDExitPhraseDiv>
                    </ACDTextDiv>
                </ACDComponentsDiv>
            </ACDDiv>
        )
    }

    function mainPageTransition(){
        dispatch(reset())
        history.push('/')
    }

    function loginPageTransition(){
        dispatch(reset())
        history.push('/login')
    }

    return (
        <>
            {viewer}
        </>
    )
}

export default AccountConfirmDisp